var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5,3H12V0H9.5C7.6,0,6,1.6,6,3.5V5H4v3h2v8h3V8h2.5L12,5H9V3.5C9,3.2,9.2,3,9.5,3z","fill":"currentColor"}));
}

Facebook.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
